<template>
  <div class="wx_login">
    <div class="login_wrap">
      <img alt src="../../assets/img/loading.gif">微信授权中…
    </div>
  </div>
</template>
<script>

import help from '@/common/help';
import { LoginByWeChat } from '../../api/home';
import { GetUserInfo, wxAuth } from '@/api/user';
import config from '@/common/config';
export default {
  data() {
    return {
      redirect: sessionStorage.getItem('redirect') || 'user',
      baseURL: process.env.NODE_ENV === 'development' ? config.baseUrl.dev : document.location.protocol + '//' + window.location.host,
      // baseURL: process.env.NODE_ENV === 'development' ? config.baseUrl.dev : config.baseUrl.pro,
      fromInfo: {}
    };
  },
  created() {
    const code = this.getUrlParam('code');
    if (code) {
      this.wxLogin(code);
    } else {
      sessionStorage.setItem('redirect', this.$route.query.redirect || 'user');
      this._weChatAuth();
    }
  },
  methods: {
    _weChatAuth() {
      window.location.href = this.baseURL + '/wechat/wx-auth?redirectUrl=' + document.location.protocol + '//' + window.location.host + '/#/wx_login';
    },
    getUrlParam(variable) {
      var query = window.location.search.substring(1);
      var vars = query.split('&');
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split('=');
        if (pair[0] == variable) { return pair[1]; }
      }
      return (false);
    },
    getUserInfo() {
      const data = {};
      GetUserInfo(data).then(res => {
        if (res.data) {
          this.redirect ? window.location.href = document.location.protocol + '//' + window.location.host + '/#' + this.redirect : window.location.href = document.location.protocol + '//' + window.location.host;
        } else {
          // this.$router.push({ name: 'bind' })
          const enterUrl = this.redirect ? document.location.protocol + '//' + window.location.host + '/#' + this.redirect : document.location.protocol + '//' + window.location.host;
          sessionStorage.setItem('enterUrl', enterUrl);
          sessionStorage.getItem('redirect');
          const redirectUrl = sessionStorage.getItem('redirect');
          if (redirectUrl.indexOf('invitations') !== -1) { // 邀请函无需调到bind
            window.location.href = document.location.protocol + '//' + window.location.host + '/#' + redirectUrl;
          } else {
            window.location.href = document.location.protocol + '//' + window.location.host + '/#/bind';
          }
        }
      });
    },
    wxLogin(weChatOpenId) {
      if (!weChatOpenId) {
        return;
      }
      const data = {
        code: weChatOpenId
      };
      LoginByWeChat(data)
        .then(res => {
          if (res.code === 200) {
            const data = res.data;
            if (data) {
              help.setToken(data.token);
              help.setSecret(data.secret);
            }
            this.getUserInfo();
          }
        })
        .catch(error => {
          console.log(error);
        });
    }
  }
};
</script>
<style lang="less">
.wx_login {
  position: relative;
  height: 100vh;
  width: 100vw;
  background: #fff;
  .login_wrap {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    text-align: center;
    width: 80%;
    height: 0.25rem;
    font-size: 0.14rem;
    color: #888;
    line-height: 0.3rem;
    img {
      vertical-align: middle;
    }
  }
}
</style>
